import React from 'react';
import { Users, Phone, LayoutDashboard } from 'lucide-react';

export const CrmTeaserSection: React.FC = () => {
  return (
    <section className="py-24 relative overflow-hidden bg-[var(--ym-prospect-surface)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          
          <div className="order-2 lg:order-1 relative aspect-square md:aspect-[4/3] rounded-3xl overflow-hidden ym-clean-card group border border-white/10 shadow-2xl">
            <div className="absolute inset-0 flex items-center justify-center bg-[var(--ym-prospect-bg)]">
              <Users className="w-24 h-24 text-[var(--ym-prospect-primary)]/20" />
            </div>
            {/* Kanban Mockup */}
            <div className="absolute inset-4 flex gap-4">
              <div className="flex-1 bg-white/5 rounded-xl border border-white/10 p-4">
                <div className="w-20 h-3 bg-white/20 rounded-full mb-4" />
                <div className="w-full h-24 bg-[var(--ym-prospect-surface)] rounded-lg mb-3 shadow-sm border border-white/5" />
                <div className="w-full h-24 bg-[var(--ym-prospect-surface)] rounded-lg shadow-sm border border-white/5" />
              </div>
              <div className="flex-1 bg-white/5 rounded-xl border border-white/10 p-4 opacity-50">
                <div className="w-20 h-3 bg-white/20 rounded-full mb-4" />
                <div className="w-full h-24 bg-[var(--ym-prospect-primary)]/10 rounded-lg border border-[var(--ym-prospect-primary)]/20" />
              </div>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-500/10 text-indigo-400 border border-indigo-500/20 mb-6">
              <LayoutDashboard className="w-4 h-4" />
              <span className="text-sm font-semibold tracking-wide uppercase">CRM & Vendas</span>
            </div>
            
            <h2 className="text-4xl lg:text-5xl font-black text-white tracking-tighter leading-tight mb-6">
              O controle de <br />
              seus passageiros.
            </h2>
            
            <p className="text-lg text-slate-300 font-light leading-relaxed mb-8">
              Saber quem está cotando, quem comprou e quem está na viagem é fundamental. Nossa ferramenta de CRM permite que sua equipe acompanhe o funil de vendas, gerencie vouchers e dispare mensagens em lote pelo WhatsApp.
            </p>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10">
              <div className="ym-clean-card p-4">
                <Users className="w-8 h-8 text-[var(--ym-prospect-primary)] mb-3" />
                <h4 className="font-bold text-white mb-1">Gestão de Passageiros</h4>
                <p className="text-sm text-slate-400">Dados, passaportes e preferências.</p>
              </div>
              <div className="ym-clean-card p-4">
                <Phone className="w-8 h-8 text-[#10B981] mb-3" />
                <h4 className="font-bold text-white mb-1">Integração WhatsApp</h4>
                <p className="text-sm text-slate-400">Atendimento humanizado rápido.</p>
              </div>
            </div>
            
          </div>
          
        </div>
      </div>
    </section>
  );
};
